import { Link } from "@inertiajs/react";
import {
  categoryColorMap,
  categoryHoverColorMap,
} from "constants/TagCategories";
import classNames from "lib/classNames";
import Button from "hardcover-ui/components/Button";
import { useMemo, useState } from "react";
import { IconThemeProps } from "hardcover-ui/theme/components/icon";
import { TagSerializersBasicTag } from "types/serializers";
import TagIcon from "./TagIcon";

function TagListTag({
  tag,
  showCount,
  size,
  showSpoilers,
}: {
  tag: TagSerializersBasicTag;
  showCount: boolean;
  size: IconThemeProps["size"];
  showSpoilers: boolean;
}) {
  const [isSpoiler, setIsSpoiler] = useState(
    tag.spoilerRatio > 0.5 || tag.category === "Content Warning"
  );
  const blurSpoiler = useMemo(() => {
    if (!isSpoiler) {
      return false;
    }
    return isSpoiler && !showSpoilers;
  }, [isSpoiler, showSpoilers]);
  return (
    <li
      key={`category-${tag.category}-tag-${tag.tag}`}
      className={classNames(
        "inline relative group",
        "group rounded-full font-medium",
        size === "sm" ? "text-base" : "",
        size === "xs" ? "text-sm" : "",
        categoryColorMap[tag.category] || categoryColorMap.Tag,
        categoryHoverColorMap[tag.category] || categoryHoverColorMap.Tag
      )}
    >
      <Link
        href={`/browse/tags/${tag.categorySlug}/${tag.tagSlug}`}
        className={classNames(
          blurSpoiler ? "blur-sm" : "",
          "flex space-x-2 items-center",
          size === "sm" ? "px-3 py-0.5" : "",
          size === "xs" ? "px-1.5 py-0.5" : ""
        )}
        onClick={(e) => (blurSpoiler ? e.preventDefault() : true)}
      >
        <TagIcon tag={tag} size={size} />
        <span className="capitalize text-sm font-semibold ">{tag.tag}</span>
        {showCount && (
          <span className="text-secondary">{tag.count.toLocaleString()}</span>
        )}
      </Link>
      {blurSpoiler && (
        <Button
          className="hidden group-hover:block absolute top-0 left-0 h-full w-full text-sm font-semibold"
          onClick={() => setIsSpoiler(false)}
        >
          Reveal
        </Button>
      )}
    </li>
  );
}
export default function TagListLinks({
  tags = [],
  limit = null,
  showCount = false,
  size = "sm",
  showSpoilers = false,
}: {
  tags: TagSerializersBasicTag[];
  limit?: number;
  showCount?: boolean;
  size?: IconThemeProps["size"];
  showSpoilers?: boolean;
}) {
  if(!tags || tags.length === 0) {
    return false;
  }

  return (
    <ul className="flex flex-wrap gap-2 text-sm">
      {tags.slice(0, limit || tags.length).map((tag) => (
        <TagListTag
          tag={tag}
          key={`tag-${tag.tagSlug}-${tag.categorySlug}`}
          showCount={showCount}
          size={size}
          showSpoilers={showSpoilers}
        />
      ))}
    </ul>
  );
}
